import NotFound from 'components/NotFound';
import PatientAccount from 'components/practice/charts/Account/Account';
import CConFile from 'components/practice/charts/Account/tabs/CConFile/CConFileTable';
import PurchasedPackages from 'components/practice/charts/Account/tabs/PurchasedPackages/PurchasedPackages';
import Quotes from 'components/practice/charts/Account/tabs/Quotes/Quotes';
import PracticePatientSettings from 'components/practice/charts/PracticePatientSettings';

const PRACTICE_CHARTS_ACCOUNT = [
  {
    path: 'account',
    element: <PatientAccount />,
    children: [
      {
        path: '',
        element: <PurchasedPackages />
      },
      {
        path: 'purchased-packages',
        element: <PurchasedPackages />
      },
      {
        path: 'quotes',
        element: <Quotes />
      },
      {
        path: 'settings',
        element: <PracticePatientSettings />
      },
      {
        path: 'cards',
        element: <CConFile />
      },
      {
        path: '*',
        element: <NotFound />
      }
    ]
  }
];
export default PRACTICE_CHARTS_ACCOUNT;
